@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
}

.visibility {
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-bottom: $spacing-s;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.selectDiscount {
  margin-bottom: $spacing-m;
}

.subtitle {
  font-size: $fontSize-xs;
}

.descriptionCard {
  margin-bottom: $spacing-s;
  border-radius: 12px !important;
}

.chips {
  margin-top: -42px;
  margin-bottom: $spacing-m;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
